import { TrendingDown, Compass, Clock3, RefreshCcw } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const benefits = [
  {
    icon: TrendingDown,
    title: "Por que os velhos métodos falham",
    text: "Dietas rígidas e restrição extrema derrubam ainda mais o seu metabolismo depois dos 40. Você não precisa de mais privação — precisa de um plano na ordem certa.",
  },
  {
    icon: Compass,
    title: "Método, não motivação",
    text: "Motivação acaba; processo permanece. O Plano 40+ transforma informação solta em um caminho passo a passo que funciona mesmo nos dias de baixa vontade.",
  },
  {
    icon: Clock3,
    title: "21 dias sem caos",
    text: "Mudanças progressivas em vez de revoluções impossíveis. Poucos minutos por dia para organizar sua rotina e ver a primeira roupa voltar a servir.",
  },
  {
    icon: RefreshCcw,
    title: "Ajuste sem recomeçar",
    text: "Aprenda a medir o que realmente importa e a corrigir a rota sem jogar fora o progresso feito — o fim do ciclo de começar e desistir.",
  },
];

const Benefits = () => (
  <section id="beneficios" data-testid="benefits-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mb-16 grid grid-cols-1 gap-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <p className="eyebrow mb-5 text-accent">O problema</p>
          <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Não é falta de força de vontade.{" "}
            <span className="italic text-primary">É falta de método.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="flex items-end lg:col-span-6 lg:col-start-7">
          <p className="text-lg leading-relaxed text-muted-foreground">
            Depois dos 40, o corpo muda — e a estratégia precisa mudar junto. O Plano 40+ foi
            desenhado exatamente para essa nova fase: prático, direto e possível de manter.
          </p>
        </Reveal>
      </div>

      <div data-testid="benefits-grid" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8">
        {benefits.map((benefit, i) => (
          <Reveal key={benefit.title} delay={i * 0.1}>
            <article
              data-testid={`benefit-card-${i + 1}`}
              className="group h-full rounded-2xl border border-border bg-card p-8 shadow-sm transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-primary/40 hover:shadow-xl sm:p-10"
            >
              <span className="font-mono-accent text-xs tracking-[0.2em] text-muted-foreground">
                0{i + 1}
              </span>
              <benefit.icon className="mt-6 h-8 w-8 text-accent transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110" />
              <h3 className="mt-5 font-display text-2xl font-semibold leading-snug text-foreground">
                {benefit.title}
              </h3>
              <p className="mt-4 leading-relaxed text-muted-foreground">{benefit.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Benefits;
